export default __webpack_public_path__ + "static/media/pantry2-after1-1920w.415a1150.avif";